function satisfiesVersion(current, required) {
    if (!current || !required) return false;
    const c = current.split('.').map(Number);
    const r = required.split('.').map(Number);
    for (let i = 0; i < 3; i++) {
        if ((c[i] || 0) > (r[i] || 0)) return true;
        if ((c[i] || 0) < (r[i] || 0)) return false;
    }
    return true;
}

export { satisfiesVersion };

export default {
    mounted(el, binding) {
        const required = binding.value;
        const current = import.meta.env.VITE_APP_VERSION;
        if (!satisfiesVersion(current, required)) {
            el.remove();
        }
    },
}
